import { useState, useEffect } from "react";
import { type NetworkInformation, type Navigator } from "@akina/infra";

export const useDetectNetworkEffectiveType = () => {
  const [isSlowConnection, setIsSlowConnection] = useState(false);
  const [currentConnectionType, setCurrentConnectionType] = useState<NetworkInformation["effectiveType"]>("default");

  useEffect(() => {
    const connection = (navigator as Navigator).connection;
    if (connection) {
      const updateConnectionStatus = (event: Event) => {
        const networkInfo = event.currentTarget as NetworkInformation;
        const effectiveType = networkInfo.effectiveType;
        if (effectiveType) {
          setIsSlowConnection(["slow-2g", "2g", "3g"].includes(effectiveType));
          setCurrentConnectionType(effectiveType);
        }
      };

      connection.addEventListener("change", updateConnectionStatus);

      if (connection.effectiveType) {
        setIsSlowConnection(["slow-2g", "2g", "3g"].includes(connection.effectiveType));
        setCurrentConnectionType(connection.effectiveType);
      }
      return () => {
        connection.removeEventListener("change", updateConnectionStatus);
      };
    }
  }, []);

  return { isSlowConnection, currentConnectionType };
};
